export default "__VITE_ASSET__DHMv$MSn__"